import stringsoflanguages from '../component/stringsoflanguages';

/** Must match keys in stringsoflanguages.js */
const SUPPORTED = new Set(['en', 'fr', 'Du', 'pt']);

/**
 * Map API / UI values to internal codes: en, fr, Du, pt.
 * Dutch is stored as "Du" (per product convention).
 */
export function normalizeAppLanguageCode(raw) {
    if (raw == null || raw === '') return 'en';
    const v = String(raw).trim();
    if (SUPPORTED.has(v)) return v;

    const uiNames = {
        English: 'en',
        Nederlands: 'Du',
        Francais: 'fr',
        Portugues: 'pt',
    };
    if (uiNames[v] != null) return uiNames[v];

    const lower = v.toLowerCase();

    if (lower === 'du' || lower === 'nl' || lower === 'nederlands' || lower === 'dutch') return 'Du';
    if (lower === 'en' || lower === 'english') return 'en';
    if (lower === 'fr' || lower === 'french' || lower === 'francais' || lower === 'français') return 'fr';
    if (lower === 'pt' || lower === 'portuguese' || lower === 'portugues' || lower === 'português') return 'pt';

    return 'en';
}

/** Profile dropdown labels (normalizeAppLanguageFromApi) → short code for strings + localStorage */
export function profileLanguageLabelToCode(label) {
    const map = {
        English: 'en',
        Francais: 'fr',
        Nederlands: 'Du',
        Portugues: 'pt',
    };
    if (label != null && map[label] != null) return map[label];
    return normalizeAppLanguageCode(label);
}

export function applyAppLanguageFromStorage() {
    if (typeof localStorage === 'undefined') return 'en';
    const code = normalizeAppLanguageCode(localStorage.getItem('app_language'));
    stringsoflanguages.setLanguage(code);
    return code;
}

/**
 * Persist preference, apply strings, notify listeners so the UI re-renders.
 */
export function setAppLanguageAndNotify(raw) {
    const code = normalizeAppLanguageCode(raw);
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('app_language', code);
    }
    stringsoflanguages.setLanguage(code);
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('appLanguageChanged', { detail: { code } }));
    }
}

if (typeof window !== 'undefined') {
    applyAppLanguageFromStorage();
}
